import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('SHIPPING_COSTS_REPORT', ['MAIN', 'FILTER_FORM'])
